<script>
export default {
    name: "VProjectSubstatus",
    props: {
        substatusColor: {
            type: String,
            default: null,
            description: "Hex color for substatus background"
        },
        tag: {
            type: String,
            default: "div",
            description: "HTML tag to render (e.g., 'td', 'div', 'span')"
        }
    },
    computed: {
        componentStyle() {
            if (this.substatusColor) {
                return {
                    backgroundColor: this.substatusColor,
                    color: this.getContrastColor(this.substatusColor)
                };
            }
            return {};
        }
    },
    methods: {
        getContrastColor(hexColor) {
            // Map specific substatus colors to their best contrasting text color
            const colors = {
                "#ffc4c4": "#9d6464",
                "#f7cb9f": "#5c3604",
                "#fff4d1": "#716c2f",
                "#def7e1": "green"
            };

            return colors[hexColor];
        }
    }
};
</script>

<template>
    <component :is="tag" :style="componentStyle">
        <slot></slot>
    </component>
</template>

<style scoped>
/* Add any additional styling if needed */
</style>
